module.exports = __webpack_public_path__ + "img/vigour-cleaf-mini.c1904ada.png";